import _ from 'lodash'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import ImagePicker from 'scoreboard/components/image-picker'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import template from './edit-project-dialog.hbs'

const EditProjectDialog = Backbone.View.extend({

	tagName: 'form',

	className: 'edit-project-dialog',

	/**
	 * @property {Project} model
	 * @param options
	 */
	initialize: function (options) {
		this.options = options || {}
		this.markedFields = []
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
		this._imageId = this.model.get('logoFileId')
	},

	render: function () {
		const hbsContext = _.extend({}, this.options, {
			headerLabel: i18n.get(this.model.isNew() ? 'common.new2' : 'common.edit2', 'common.project.project')
		})
		this._imageId = this.model.get('logoFileId')
		this.$el.empty().append(template(hbsContext))
		this._renderImagePicker()

		formHelper.writeToDom(this.model, this.el)

		this.markedFields.push(new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render())

		this.formView.start()

		return this
	},

	_renderImagePicker() {
		this._imagePicker = new ImagePicker({
			className: 'project-image-picker',
			uploadLabelKey: 'common.project.icon.upload',
			deleteLabelKey: 'common.project.icon.delete',
			imgClass: 'project-image',
			smallButtons: true
		})
		this.$('label.full-width').before(this._imagePicker.el)
		this._imagePicker.render()

		this._imagePicker.on('pick', image => {
			this._image = image
			delete this._imageId
			delete this._deleteImage
			this.formView.change()
			this.$('.icon-project').addClass('is-not-displayed')
		})

		this._imagePicker.on('delete', () => {
			delete this._image
			delete this._imageId
			this._deleteImage = true
			this.formView.change()
			this.$('.icon-project').removeClass('is-not-displayed')
		})

		if (this._imageId) {
			this.$('.icon-project').addClass('is-not-displayed')
			this._imagePicker.imageId(this._imageId)
		}

		this.on('resize', () => this._imagePicker.trigger('resize'))
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._markedFields, this._imagePicker], 'remove')
	},

	submit: function () {
		const {label} = formHelper.readFromDom(this.el)
		const action = this.model.isNew() ? 'add' : 'edit'
		this._deleteImage && this.model.unset('logoFileId')
		this.model.save({label, logoImage: this._image}, {
			success: () => {
				Backbone.trigger(`${action}:domain-object`, this.model)
				this.trigger('done')
			}
		})
	}
})

export default EditProjectDialog

EditProjectDialog.__filename__ = 'projects/edit-project-dialog.js'
